import '.m{flex:1;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.bc{align-items:start;}.ssr-plugin'
import '.b8{gap:8px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import { ReactNode } from 'react'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { Icon } from '../Icon/index.js'
import { Note, NoteProps } from '../Note/index.js'
import { styled } from 'inlines'

type FormFieldProps = {
  label?: string
  description?: string
  error?: string
  children: ReactNode
  note?: Pick<NoteProps, 'title' | 'description'>
}

function FormField({
  children,
  label,
  description,
  error,
  note,
}: FormFieldProps) {
  return (
    <div className="m h a i bc b8"
    >
      {label && (
        <Text variant="subtext-regular" color="neutral60">
          {label}
        </Text>
      )}
      <div className="h">{children}</div>

      {error && (
        <div className="a d a3"
          style={{
            color: colors.red100,
          }}
        >
          <Icon variant="error-filled" color="red100" />
          <Text color="inherit" variant="display-medium">
            {error}
          </Text>
        </div>
      )}
      {description && (
        <Text variant="display-regular" color="neutral60">
          {description}
        </Text>
      )}
      {note && <Note {...note} />}
    </div>
  )
}

export { FormField }
export type { FormFieldProps }
